// The shared letter-fallback avatar (components/UI/Avatar.jsx) hardcodes
// white text over whichever of these is picked. Every one of the original
// ten — vivid "Tailwind-500" tones — measured under 4.5:1 against white,
// several as low as ~2:1. These are each hue's "-700" tier instead, the
// standard accessible pairing for white text at small sizes.
const AVATAR_COLORS = [
  '#C2410C', '#1D4ED8', '#047857', '#6D28D9',
  '#B45309', '#B91C1C', '#0E7490', '#BE185D',
  '#4D7C0F', '#4338CA',
];

export function getAvatarColor(firstName, lastName) {
  const str = `${firstName || ''}${lastName || ''}`;
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}
